export class OwnerChangeRequest {
  ApplicationId: string[];
  MuteNotification: boolean;
  NewOwnerUsername: string;
}
